"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globals_1 = require("../../infra/globals");
class AboutView extends HTMLElement {
    static tag = "about-view";
    async connectedCallback() {
        document.title = "RBGo | Sobre";
        this.setContent();
    }
    static moderatorEmail = "moderador@rbgo.com.br";
    get moderatorLinkString() {
        return `
      <a href="mailto:${AboutView.moderatorEmail}">moderador</a>
    `;
    }
    setContent = () => {
        this.innerHTML = `
      <h1>Sobre o Ranking Brasileiro de Go (RBGo)</h1>
      
      <ol>
        <li>
          <h2>Qual é o propósito do RBGo?</h2>

            <p>
              Proporcionar uma maneira de se registrar e arquivar partidas e a
              progressão do Go e dos jogadores brasileiros.
            </p>
        </li>
        <li>
          <h2>Como faço para ser incluído no RBGo?</h2>

            <p>
               Mande um email para o ${this.moderatorLinkString}
               com os seus dados:
            </p>

            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Dado</th>
                  <th>Obrigatório?</th>
                  <th>Mais informações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Nome Completo</td>
                  <td>Sim</td>
                  <td>${globals_1.emdash}</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Email</td>
                  <td>Não</td>
                  <td>Recomendado, vide o próximo item</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Foto</td>
                  <td>Não</td>
                  <td>${globals_1.emdash}</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>País(es) de Origem</td>
                  <td>Sim</td>
                  <td>
                    Se brasileiro, opcionalmente, adicionar estado e
                    cidade
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Nível em um dos Servidores Conhecidos</td>
                  <td>Sim</td>
                  <td>ex.: KGS, OGS, Fox, Tygem, etc.</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>3 Partidas Recentes</td>
                  <td>Sim</td>
                  <td>${globals_1.emdash}</td>
                </tr>
              </tbody>
            </table>
        </li>
        <li>
          <h2>Como adicionar uma partida ao RBGo?</h2>
          
            <p>
              Após ter feito seu cadastro, mande uma mensagem com a sua partida
              para o ${this.moderatorLinkString} com os dados da partida e,
              preferencialmente, o arquivo SGF.
            </p>

            <p>
              Há planos para que, no futuro, maneiras mais automatizadas de se
              adicionar partidas à plataforma sejam criadas, porém, de maneira
              geral, as partidas dentro desta plataforma seriam curadas por
              moderadores e não partidas quaisquer.
            </p>
              
            <p>
              Uma das funcionalidades extras do RBGo é a possibilidade de 
              registro de partidas "avulsas", isto é, não relacionadas a
              torneios, sejam elas online ou presenciais. Para tal, porém, é
              preciso que ambos os jogadores dêem aval via email, separadamente.
              (Em torneios, isto é desnecessário, devido à presença de juiz.)
            </p>
        </li>
        <li>
          <h2>Quero ajudar a melhorar o RBGo. Por onde posso fazê-lo?</h2>
          
            <p>
              O RBGo é um projeto em código aberto, ou seja, a infraestrutura é
              inspecionável por qualquer um. Se você quiser e puder acrescentar
              ou melhorar alguma funcionalidade é só 
                <a href="${globals_1.repoUrl}">
                  adicionar um <i>pull request</i> no Github.
                </a>
              Caso você tenha alguma sugestão de funcionalidade mas não consiga
              ou não queira implementá-la, também é possível deixar a sugestão
              no repositório do Github.
            </p>
        </li>
        <li>
          <h2>Quem cuida do RBGo?</h2>
          
            <p>
              Se você quiser ajudar, toda ajuda é bem-vinda, mas, no momento,
              os integrantes da equipe são:
            </p>
              
            <table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Funções</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Philippe Fanaro</td>
                  <td>Desenvolvedor e Moderador</td>
                </tr>
              </tbody>
            </table>
        </li>
      </ol>
    `;
    };
}
exports.default = AboutView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWJvdXQtdmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91aS92aWV3cy9hYm91dC12aWV3LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaURBQXNEO0FBRXRELE1BQXFCLFNBQVUsU0FBUSxXQUFXO0lBQ2hELE1BQU0sQ0FBVSxHQUFHLEdBQVcsWUFBWSxDQUFDO0lBRTNDLEtBQUssQ0FBQyxpQkFBaUI7UUFDckIsUUFBUSxDQUFDLEtBQUssR0FBRyxjQUFjLENBQUM7UUFFaEMsSUFBSSxDQUFDLFVBQVUsRUFBRSxDQUFDO0lBQ3BCLENBQUM7SUFFTyxNQUFNLENBQVUsY0FBYyxHQUFXLHVCQUF1QixDQUFDO0lBRXpFLElBQVksbUJBQW1CO1FBQzdCLE9BQWdCO3dCQUNJLFNBQVMsQ0FBQyxjQUFjO0tBQzNDLENBQUM7SUFDSixDQUFDO0lBRU8sVUFBVSxHQUFHLEdBQVMsRUFBRTtRQUM5QixJQUFJLENBQUMsU0FBUyxHQUFZOzs7Ozs7Ozs7Ozs7Ozs7O3VDQWdCUyxJQUFJLENBQUMsbUJBQW1COzs7Ozs7Ozs7Ozs7Ozs7Ozs7d0JBa0J2QyxnQkFBTTs7Ozs7Ozs7Ozs7O3dCQVlOLGdCQUFNOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7d0JBcUJOLGdCQUFNOzs7Ozs7Ozs7O3VCQVVQLElBQUksQ0FBQyxtQkFBbUI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzJCQTBCcEIsaUJBQU87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0tBZ0M3QixDQUFDO0lBQ0osQ0FBQyxDQUFDOztBQTFKSiw0QkEySkMifQ==